import React from "react";
import ContactForm from "../contactform/contactform.component";

export default function PercheScegliere({ content }) {
  const data = content[0];

  return (
    <section
      id="perchescegliere"
      className="bg-white py-16 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-7xl mx-auto text-center">
        {/* Main Title */}
        <h2
          data-aos="fade-up"
          className="text-4xl md:text-6xl font-black text-black mb-8"
        >
          {data.title}
        </h2>

        {/* Main Description */}
        <p
          data-aos="fade-up"
          data-aos-delay="200"
          className="text-lg md:text-xl text-gray-700 max-w-4xl mx-auto mb-16 leading-relaxed"
        >
          {data.description}
        </p>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
          {data.features.map((feature, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={300 + index * 100}
              className="text-center px-4 max-w-lg"
            >
              <h3 className="text-2xl md:text-3xl font-bold text-giallomoretti mb-4">
                {feature.title}
              </h3>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16">
          <h2
            data-aos="fade-up"
            className="text-4xl md:text-5xl font-black text-giallomoretti mb-8"
          >
            {data.ctaTitle}
          </h2>
          <div data-aos="zoom-in" data-aos-delay="200">
            <ContactForm
              title={data.ctaButtonText}
              description="Compila il modulo per richiedere informazioni sull'F4."
              whatsappLink="https://wa.me/393442741976"
              dimensionifont="text-xl md:text-3xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
